import { healthResponseSchema, type HealthResponse } from '@personal-os/shared';

/**
 * Fetches the server's health report. A 503 still carries a valid report
 * (status "degraded"); only network failures and malformed replies throw.
 */
export async function fetchHealth(signal?: AbortSignal): Promise<HealthResponse> {
  const res = await fetch('/api/health', { signal: signal ?? null, cache: 'no-store' });
  const body: unknown = await res.json();
  return healthResponseSchema.parse(body);
}
